<template>
  <div class="loginForm">
    <van-nav-bar
      :title="oneTitle"
      class="main-nav"
      :left-arrow="flag !== 1"
      @click-left="onClickLeft"
    />
    <div class="login">
      <img :src="logoPic" alt="" class="logo" />
      <p class="frist-p">
        {{ flag == 1 ? "手机号" : ""
        }}{{
          oneTitle === "找回密码"
            ? "忘记密码"
            : flag == 3
            ? "设置密码"
            : flag == 5
            ? "设置密码"
            : oneTitle
        }}
        <!-- <span class="title-sub second-p">(内测版)</span> -->
      </p>
      <p class="second-p">{{ twoTitle }}</p>
      <div class="form-table">
        <van-form @submit="onSubmit" validate-trigger="onSubmit">
          <van-field
            v-model="phone"
            name="phone"
            placeholder="请输入手机号"
            type="tel"
            maxlength="11"
            v-if="flag != 3 && flag != 5"
            @blur="checkedPhone"
          />
          <div class="empty" v-if="flag == 1 || flag == 2 || flag == 4"></div>
          <van-field
            v-model="smsCode"
            name="smsCode"
            center
            clearable
            label
            type="number"
            placeholder="请输入验证码"
            class="smsCode-input"
            v-if="flag != 1 && flag != 3 && flag != 5"
            maxlength="6"
          >
            <template #button>
              <input
                readonly
                class="push-btn"
                @click="sendCode"
                :disabled="btnStatus"
                :value="
                  verifyCode == '获取验证码' ? verifyCode : verifyCode + 's'
                "
              />
            </template>
          </van-field>
          <van-field
            v-model="password"
            :type="passtype"
            name="password"
            :class="{ extra: flag == 1 }"
            label
            :placeholder="placeholderText"
            maxlength="13"
            v-if="flag != 2 && flag != 4"
          >
            <template #button>
              <img
                :src="imgFlag ? colseImg : openImg"
                class="filedimg"
                @click="checkImg"
              />
            </template>
          </van-field>
          <div class="empty" v-if="flag == 3 || flag == 5"></div>
          <van-field
            v-model="confirmPassword"
            :type="passedtype"
            name="confirmPassword"
            label
            :placeholder="placeholderText1"
            v-if="flag != 1 && flag != 2 && flag != 4"
            class="extra"
            maxlength="13"
            @blur="checkedConfirmPassword"
          >
            <template #button>
              <img
                :src="imgedFlag ? colseImg : openImg"
                class="filedimg"
                @click="checkedImg"
              />
            </template>
          </van-field>

          <!-- <div class="login-desc second-p">
            <p>尊敬的用户，您好！</p>
            <p class="indent2em">本平台当前处于内测阶段，如您在使用过程中遇到问题，可通过mindbridge@bjhorin.com邮箱与我们取得联系，感谢您的支持！</p>
          </div> -->
          <div style="text-align: center">
            <van-button class="btn-login" type="info" native-type="submit">{{
              btnText
            }}</van-button>
          </div>
          <p
            class="third-p"
            :style="{
              textAlign:
                flag == 2 || flag == 3 || flag == 4 || flag == 5
                  ? 'center'
                  : 'justify',
            }"
          >
            <span class="span-color" v-if="flag == 1">
              <b
                @click="
                  isRead = false;
                  updateFlag(2);
                "
                class="defalut-b defalut-regist"
                >立即注册</b
              >
            </span>
            <span
              class="span-color"
              v-if="flag == 2 || flag == 3 || flag == 4 || flag == 5"
            >
              <b
                @click="
                  isRead = false;
                  updateFlag(1);
                "
                class="defalut-b"
                ><span style="color: #949c9d">已有密码，</span>立即登录</b
              >
            </span>
            <span
              class="defalut-b"
              @click="
                isRead = false;
                updateFlag(4);
              "
              style="float: right"
              v-if="flag == 1"
              ><span style="color: #949c9d">忘记密码？</span>找回密码</span
            >
          </p>
          <!-- v-if="flag == 3" -->
          <div class="read-box" v-if="flag == 1 || flag == 2">
            <img
              :src="isRead ? yesIcon : noIcon"
              class="read-img"
              @click="checkedRead"
            />
            <span class="read-span">
              已阅读并同意
              <span
                class="defalut-b"
                style="color: #00aadf"
                @click="privacyBtn(index)"
                v-for="(el, index) in contents"
                :key="index"
                >《{{ el.title }}》<b
                  style="color: #999; font-weight: normal"
                  >{{ index !== contents.length - 1 ? "和" : "" }}</b
                ></span
              >
            </span>
          </div>
        </van-form>
      </div>
    </div>
    <!-- 隐私条款 -->
    <van-overlay
      :show="showRead"
      style="height: calc(100%)"
      :lock-scroll="false"
    >
      <div class="register-code">
        <div class="informedConsent">
          <p
            class="p18"
          >
            {{ title }}
          </p>
          <van-icon name="cross" size="20" class="closePop" @click="closePop" />
          <div class="esign">
            <!-- @scroll="scrollEvent" -->
            <div class="mainContent">
              <div ref="contents">
                <!-- <div v-for="(item, index) in contents" :key="index"> -->
                <div>
                  <p class="content" v-html="curContent"></p>
                </div>
              </div>
            </div>
            <!-- <div class="footerEdit">
              <div v-for="ite in contents" class="isReadBox" :key="ite.title">
                <van-checkbox-group
                  v-model="result"
                  direction="horizontal"
                  @change="checkgroupChange"
                >
                  <van-checkbox
                    shape="square"
                    checked-color="#FF8E4B"
                    :name="ite.id"
                    >《{{ ite.title }}》</van-checkbox
                  >
                </van-checkbox-group>
              </div>
              <div style="position: relative"> -->
            <!--                <van-icon class="esign-clear" size="1.6rem" name="clear"  />-->
            <!-- <div class="esign-clear" @click="clearCvs">重置</div>
                <div class="gradientLayer" v-if="showGradient"></div>
                <div class="drawingBoard">
                  <vue-esign
                    ref="esign"
                    class="signature"
                    :width="275"
                    :height="100"
                    :isCrop="isCrop"
                    :lineWidth="lineWidth"
                    :lineColor="lineColor"
                    :bgColor.sync="bgColor"
                  />
                </div>
              </div>
              <p
                class="p18"
                style="
                  color: #ff8400;
                  margin-bottom: 10px;
                  margin-top: -10px;
                  font-size: 12px;
                  font-weight: 800;
                "
              >
                需将协议阅读完成并在屏幕中签名才可以点击"同意"
              </p>
            </div> -->
          </div>
          <!-- && !resultImg -->
          <van-button class="code-btn" :disabled="readTime" @click="agreeBtn">
            同意
            <span v-if="showRead && !resultImg">{{
              seconds === 0 ? "" : `(${seconds}s)`
            }}</span>
          </van-button>
        </div>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import {
  validateMobile,
  validatePassword,
  validatePassword1,
} from "../../common/validate";
import { encryptBy, decryptBy } from "../../assets/js/encryption";
import { verticalScreen } from "../../assets/js/vertical-screen";
import { Dialog } from "vant";
import store from "@/store/index";
import Cookies from "js-cookie";
import { setOpenId , registerWxConfig } from "@/weixinConfig";
import {
  _getCode,
  _register,
  _login,
  _getCheckCode,
  _contentLast,
  _informedConsentUserRelation,
  _forgetPassword,
  _loginSmsCode,
  _getUser,
  _consentConfig,
  _queryInformedConsent,
  _childDetail
} from "../../api/login";
import { landType } from "@/common/utils/utils";
import BScroll from "better-scroll";

export default {
  name: "login",
  data() {
    return {
      logoPic: require("../../assets/images/login/logo.png"),
      flag: 1, // 按钮状态： 1登录，2注册下一步，3注册确认，4忘记密码下一步，5忘记密码确认
      oneTitle: "登录", // 当前状态
      twoTitle: "欢迎使用迪夫康复", // 欢迎提示语
      btnText: "登录", // 按钮文案
      placeholderText: "请输入密码", // 输入提示信息
      placeholderText1: "请输入确认密码", // 输入提示信息
      verifyCode: "获取验证码", // 获取验证码 倒计时
      btnStatus: false, // 是否可以点击
      colseImg: require("../../assets/images/login/closeicon.png"), // 密码框不可查看
      openImg: require("../../assets/images/login/openicon.png"), // 密码框可查看
      backImg: require("../../assets/images/login/back.png"), //返回按钮
      phone: "", // 手机号
      password: "", // 密码
      confirmPassword: "", // 确认密码
      smsCode: "", // 验证码
      imgFlag: true, // 是否为密码框
      imgedFlag: true, // 密码框是否为***
      passtype: "password", // 密码框状态
      passedtype: "password", // 密码框状态
      timer: null, // 倒计时
      countdown: null, // 倒计时
      count: null,
      isRead: false, // 是否勾选知情同意书
      yesIcon: require("../../assets/images/login/yes.png"), // 已勾选
      noIcon: require("../../assets/images/login/no.png"), // 未勾选
      lineWidth: 4, // 画笔的线条粗细
      lineColor: "#000", // 画笔的颜色
      bgColor: "#F2F2F2", // 画板背景色
      resultImg: "", // 最终画布生成的base64图片
      isCrop: false, // 是否裁剪，在画布设定尺寸基础上裁掉四周空白部分
      showRead: false, // 调起隐私协议
      showGradient: true,
      readTime: true, //禁用按钮
      btnColor: "#FFF", //按钮颜色
      contents: [], // 隐私协议内容
      result: [], // 知情同意书选择组
      priClaId: "", // 知情同意书ID
      version: "", // 版本
      modelType: 1, // 模块类型
      signRequired: "", // 是否必须签名 false非必须 true必须
      retentionTime: "", // 停留时间 单位：秒
      loading: false, //加载
      isScroll: false, // 是否滑动
      isStay: false, // 是否阅读30秒
      seconds: 0,
      token: "", //
      scrollBetter: null,
      curContent: {}, // 弹框内容
      title: "",
    };
  },
  async created() {
    // if(!sessionStorage.getItem("openid") && !localStorage.getItem("appid")){
    //   registerWxConfig()
    // }
  },
  mounted() {
    if (window.history && window.history.pushState) {
      // 往历史记录里面添加一条新的当前页面的url
      history.pushState(null, null, document.URL);
      // 给 popstate 绑定一个方法 监听页面刷新
      window.addEventListener("popstate", this.goBack, false); //false阻止默认事件
    }
    // console.log(typeof WeixinJSBridge.invoke, "typeof WeixinJSBridge");
    if (
      typeof WeixinJSBridge === "object" &&
      typeof WeixinJSBridge.invoke === "function"
    ) {
      this.changeSize();
    } else {
      document.addEventListener("WeixinJSBridgeReady", this.changeSize, false);
    }
    this.consentConfig();
    verticalScreen();
    document.body.addEventListener("touchstart", this.stopScroll, {
      passive: false,
    });
    document.body.style.overflow = "hidden";
    document
      .querySelectorAll(".loginForm")[0]
      .addEventListener("touchstart", function (e) {
        // e.preventDefault()
        e.stopPropagation();
      });

    // document
    //   .querySelector(".mainContent")
    //   .addEventListener("scroll", this.scrollToTop);
  },
  watch: {
    isScroll() {
      if (this.isStay) {
        // 需要执行的代码
        this.readTime = false;
        this.btnColor = "#DDD";
      }
    },
    isStay() {
      if (this.isScroll) {
        // 需要执行的代码
        this.readTime = false;
        this.btnColor = "#DDD";
      }
    },
  },

  beforeDestroy() {
    this.scrollBetter && this.scrollBetter.destroy();
    document.body.removeEventListener("touchstart", this.stopScroll);
    document.body.style.overflow = "unset";
  },
  methods: {
    goBack() {
      history.pushState(null, null, document.URL);
    },
    changeSize() {
      // 设置网页字体为默认大小
      WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });
      // 重写设置网页字体大小的事件
      WeixinJSBridge.on("menu:setfont", function () {
        WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });
      });
    },
    stopScroll(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    //初始化弹窗滚动条
    initScroll() {
      // document.body.addEventListener('touchstart', function (e) {
      //   e.preventDefault()
      //   e.stopPropagation()
      // }, false)
      this.$nextTick(() => {
        this.scrollBetter = new BScroll(".mainContent", {
          scrollbar: true,
          scrollX: false,
          scrollY: true,
          bounce: false,
          stopPropagation: true,
          pullUpLoad: true,
          click: true,
          useTransition: false,
        });
        this.scrollBetter.on("scroll", (pos) => {
          let contentY = this.$refs.contents.offsetHeight;
          let scrollY = Math.abs(Math.round(pos.y));
          let scrollH =
            document.getElementsByClassName("mainContent")[0].offsetHeight;
          this.showGradient = false;
          if (Math.abs(scrollY + scrollH - contentY) < 10) {
            this.isScroll = true;
          }
        });
      });
    },
    //清空手写内容
    clearCvs() {
      this.$refs.esign.reset();
    },
    // 左侧返回按钮
    onClickLeft() {
      switch (this.flag) {
        case 2:
          this.isRead = false;
          this.updateFlag(1);
          break;
        case 3:
          this.updateFlag(2);
          break;
        case 4:
          this.updateFlag(1);
          break;
        case 5:
          this.updateFlag(4);
          break;
      }
    },
    //切换密码
    checkImg() {
      this.imgFlag = !this.imgFlag;
      this.passtype = this.imgFlag ? "password" : "text";
    },
    //切换确认密码
    checkedImg() {
      this.imgedFlag = !this.imgedFlag;
      this.passedtype = this.imgedFlag ? "password" : "text";
    },
    //切换界面
    updateFlag(val) {
      console.log("当前flag", val);
      this.flag = val;
      //重置输入框
      this.password = "";
      this.confirmPassword = "";
      this.smsCode = "";
      this.imgFlag = true;
      this.imgedFlag = true;
      this.passtype = "password";
      this.passedtype = "password";
      clearInterval(this.timer);
      this.verifyCode = "获取验证码";
      this.btnStatus = false;
      switch (val) {
        case 1:
          this.oneTitle = "登录";
          this.twoTitle = "欢迎使用迪夫康复";
          this.placeholderText = "请输入密码";
          this.btnText = "登录";
          break;
        case 2:
          // this.handleReset();
          // 获取知情同意书
          this.consentConfig();
          this.oneTitle = "注册";
          this.twoTitle = "欢迎注册迪夫康复";
          this.placeholderText = "请输入密码";
          this.btnText = "下一步";
          break;
        case 3:
          this.twoTitle = "请输入密码，6-13位英文字母或数字";
          this.placeholderText = "请设置密码";
          this.placeholderText1 = "请确认密码";
          this.btnText = "注册";
          break;
        case 4:
          this.oneTitle = "找回密码";
          this.twoTitle = "欢迎使用迪夫康复";
          this.placeholderText = "请输入密码";
          this.btnText = "下一步";
          break;
        case 5:
          this.oneTitle = "重置密码";
          this.twoTitle = "请输入密码，6-13位英文字母或数字";
          this.placeholderText = "请设置新密码";
          this.placeholderText1 = "请确认新密码";
          this.btnText = "确定";
          break;
      }
    },
    //发送验证码
    sendCode() {
      if (!this.phone) {
        this.$toast("请输入手机号");
        return false;
      } else if (!validateMobile(this.phone)) {
        this.$toast("手机号码格式不正确，请重新输入");
        return false;
      }
      let type;
      if (this.flag === 2) {
        type = 0;
      } else {
        type = 1;
      }
      _getCode({
        origin: "C",
        phone: encryptBy(this.phone),
        type: type,
      }).then((res) => {
        if (res && res.code == 200) {
          this.verifyCode = 120;
          this.btnStatus = true;
          this.timer = setInterval(() => {
            if (this.verifyCode > 0 && this.verifyCode <= 120) {
              this.verifyCode = this.verifyCode - 1;
            } else {
              clearInterval(this.timer);
              this.verifyCode = "获取验证码";
              this.btnStatus = false;
            }
          }, 1000);
        } else {
          this.$toast(res.message);
        }
      });
    },
    //校验手机号
    checkedPhone() {
      if (!validateMobile(this.phone) && this.phone) {
        this.$toast("手机号码格式不正确，请重新输入");
      }
    },
    //校验确认密码
    checkedConfirmPassword() {
      if (this.confirmPassword !== this.password) {
        this.$toast("两次密码输入不一致，请重新输入");
        return false;
      }
    },
    // 知情同意书复选框
    checkgroupChange() {
      // if (this.resultImg) {
      //   this.isRead = true;
      // } else {
      //   this.isRead = false;
      // }
    },
    //知情同意
    checkedRead() {
      // if (this.resultImg) {
      //   // this.result = [];
      //   this.isRead = !this.isRead;
      // } else {
      //   this.$toast("请仔细阅读并勾选知情同意书");
      //   return;
      // }
      this.isRead = !this.isRead;
      // if(!this.isRead){
      //   this.$toast("请仔细阅读并勾选知情同意书");
      // }
    },
    // 关闭隐私协议弹窗
    closePop() {
      this.showRead = false;
      this.seconds = 0;
      this.readTime = true;
      this.isStay = false;
      this.isScroll = false;
      // this.handleReset();
      // if (!this.resultImg) {
      //   this.result = [];
      //   this.readTime = true;
      //   this.isStay = false;
      //   this.isScroll = false;
      // }
      // document.querySelector(".mainContent").scrollTo(0, 0);
      clearTimeout(this.countdown);
      clearTimeout(this.count);
    },
    // 清空画板
    handleReset() {
      this.$refs.esign.reset();
    },
    // 生成图片
    // handleGenerate() {
    //   this.$refs.esign
    //     .generate()
    //     .then((res) => {
    //       this.resultImg = res;
    //     })
    //     .catch((err) => {
    //       this.$toast(err); // 画布没有签字时会执行这里 'Not Signned'
    //     });
    // },
    /** 点击隐私协议触发方法 */
    privacyBtn(index) {
      // setTimeout(() => {
      //   this.consentConfig();
      //   // this.initCanvasSize();
      // }, 200);
      clearInterval(this.count);
      clearInterval(this.countdown);
      this.showRead = true;
      this.title = this.contents[index].title;
      this.curContent = this.contents[index].content;
      this.seconds = 5;
      this.countdown = setInterval(() => {
        // this.readTime = false;
        // this.btnColor = "#ddd";
        clearInterval(this.countdown);
        this.isStay = true;
        this.readTime = false;
        this.btnColor = "#DDD";
      }, 5 * 1000);
      this.count = setInterval(() => {
        this.seconds--;
        if (this.seconds <= 0) {
          clearInterval(this.count);
        }
      }, 1000);
      // this.getPrivacy()
    },
    //重设画布大小
    initCanvasSize() {
      this.$nextTick(() => {
        const board = document.getElementsByClassName("drawingBoard")[0];
        const boardHeight = board.offsetHeight;
        const boardWidth = board.offsetWidth;
        let canvas = document.getElementsByTagName("canvas")[0];
        canvas.setAttribute("width", boardWidth);
        canvas.setAttribute("height", boardHeight);
        canvas.style.height = boardHeight + "px";
        canvas.style.width = boardWidth + "px";
        let self = this;
        // document.getElementsByClassName("login")[0].addEventListener('touchstart', function (e) {
        //   if (this.showRead) {
        //     e.preventDefault()
        //     e.stopPropagation()
        //   }
        // }, false)
      });
    },
    // 滑动事件
    scrollEvent() {
      this.showGradient = false;
    },
    // 隐私协议滑动事件
    // scrollToTop() {
    //   let el = document.querySelector(".mainContent");
    //   const scrollTop = el.scrollTop;
    //   const scrollHeight = el.scrollHeight;
    //   if (el.offsetHeight + scrollTop - scrollHeight >= -1) {
    //     this.isScroll = true;
    //   }
    // },
    // 知情同意书确认
    agreeBtn() {
      // if (this.result.length !== 4) {
      //   this.$toast("请仔细阅读并勾选知情同意书");
      //   return false;
      // }
      // this.$refs.esign
      //   .generate()
      //   .then((res) => {
      //     this.resultImg = res;
      // this.isRead = true;
      this.closePop();
      // if (this.flag === 1) {
      //   this.informedConsentUserRelation();
      // }
      // })
      // .catch((err) => {
      //   this.$toast("请签署知情同意书"); // 画布没有签字时会执行这里 'Not Signned'
      // });
    },
    // 查询用户是否签署了知情同意书
    queryInformedConsent() {
      return _queryInformedConsent({
        modelType: this.modelType,
        phone: this.phone,
      }).then((res) => {
        if (res && res.code == 200) {
          if (res.data) {
            Cookies.set("token", this.token, {
              expires: Number(this.token) * 1000,
            });
            this.getUser();
            return Promise.resolve();
          } else {
            // 获取知情同意书
            this.consentConfig();
          }
        } else {
          this.loading = false;
          this.$toast(res.message);
          return false;
        }
        return Promise.reject(res);
      });
    },
    // 查询知情同意书配置接口
    consentConfig() {
      clearInterval(this.count);
      clearInterval(this.countdown);
      _consentConfig(1).then((res) => {
        if (res && res.code == 200) {
          this.version = res.data.version;
          this.modelType = res.data.modelType;
          this.signRequired = res.data.signRequired;
          // this.retentionTime = res.data.retentionTime * 1000;
          // this.seconds = parseInt(res.data.retentionTime/4);
          // this.seconds = 5;
          this.contentLast();
          // // 隐私协议弹窗定时器
          // // this.showRead = true;

          // this.countdown = setInterval(() => {
          //   // this.readTime = false;
          //   // this.btnColor = "#ddd";
          //   clearInterval(this.countdown);
          //   this.isStay = true;
          //   this.readTime = false;
          //   this.btnColor = "#DDD";
          // }, 5 * 1000);
          // this.count = setInterval(() => {
          //   this.seconds--;
          //   if (this.seconds <= 0) {
          //     clearInterval(this.count);
          //   }
          // }, 1000);
          // this.initCanvasSize();
        } else {
          this.$toast(res.message);
          return false;
        }
      });
    },
    // 获取知情同意书
    contentLast() {
      _contentLast(1, this.version).then((res) => {
        if (res && res.code == 200) {
          this.contents = res.data;
          // this.initScroll();
        } else {
          this.$toast(res.message);
          return false;
        }
      });
    },
    // 保存知情同意书
    informedConsentUserRelation() {
      this.contents.forEach((item) => {
        this.priClaId = this.priClaId + item.id + ",";
      });
      _informedConsentUserRelation({
        priClaId: this.priClaId,
        signImg: this.resultImg,
        version: this.version,
        phone: this.phone,
        modelType: this.modelType,
      }).then((res) => {
        if (res && res.code == 200) {
          if (this.flag === 1) {
            Cookies.set("token", this.token, {
              expires: Number(this.token) * 1000,
            });
            this.getUser();
          } else if (this.flag === 3) {
            // 转到登录
            this.updateFlag(1);
          }
        } else {
          this.$toast(res.message);
          return false;
        }
      });
    },
    getDetail(data) {
      if(data.userType =='THERAPISTS') {
        this.$router.replace("/");
      } else {
        _childDetail().then((res) => {
          if (res && res.code === 200) {
            let data = res.data;
            localStorage.setItem("children", encryptBy(JSON.stringify(data)));
            if(data && data.length>0) {
              this.$router.replace("/");
            } else {
              this.$router.replace("/identity");
            }
          } else {
            this.$toast(res.message);
          }
        })
      }
      
    },
    // 获取用户信息
    getUser() {
      _getUser({
        authentication: this.token,
        // origin:'C'
      }).then((res) => {
        this.loading = false;
        if (res && res.code == 200) {
          localStorage.setItem(
            "isFirstLogin",
            JSON.stringify(res.data.isFirstLogin)
          );
          localStorage.setItem(
            "isFirstLoginIndex",
            JSON.stringify(res.data.isFirstLogin)
          );
          this.$store.commit("USER_INFO", res.data);
          localStorage.setItem("userInfo", encryptBy(JSON.stringify(res.data)));
          localStorage.setItem("userPassword", res.data.password);
          if (res.data.isFirstLogin || !res.data.userType) {
            // this.$router.replace("/basicInfor");
            this.$router.replace("/identity");
          } else {
            this.getDetail(res.data);
          }
        } else {
          this.$toast(res.message);
        }
      });
    },
    // 提交
    onSubmit(val) {
      if (!this.phone) {
        this.$toast("请输入手机号");
        return false;
      } else if (!validateMobile(this.phone)) {
        this.$toast("手机号码格式不正确，请重新输入");
        return false;
      }
      if (this.flag == 1 || this.flag == 2) {
        if (!this.isRead) {
          return this.$toast("请仔细阅读并勾选《隐私政策》和《用户使用协议》");
        }
      }
      switch (this.flag) {
        case 1:
          // if(!validatePassword(val.password)){
          // 	this.$toast("请输入正确密码");
          // 	return false
          // }
          // 登录
          this.loading = true;
          _login({
            userName: encryptBy(this.phone),
            smsCode: encryptBy(this.password),
            origin: "C",
          }).then((res) => {
            if (res && res.code == 200) {
              // if(!sessionStorage.getItem("openid") && !localStorage.getItem("appid")){
              //   registerWxConfig()
              // }
              this.token = res.data;
              localStorage.removeItem("childId");
              localStorage.removeItem("children");
              // add
              Cookies.set("token", this.token, {
                expires: Number(this.token) * 1000,
              });
              landType.landByLogin();
              this.getUser();
              // this.getUser();
              // this.queryInformedConsent().then(() => {
              //   //landByLogin  1是通过登陆进的系统 2不是通过登陆进的系统(缓存) 3未登录
              //   landType.landByLogin();
              // });
            } else {
              this.$toast(res.message);
              this.loading = false;
              return false;
            }
          });
          break;
        case 2:
          // 注册，下一步
          if (!val.smsCode) {
            this.$toast("请输入验证码");
            return false;
          }
          _getCheckCode({
            phone: encryptBy(this.phone),
            code: this.smsCode,
            origin: "C",
          }).then((res) => {
            if (res && res.code == 200) {
              if (res.data) {
                this.updateFlag(3);
              } else {
                this.$toast(res.message);
              }
            } else {
              this.$toast(res.message);
              return false;
            }
          });
          break;
        case 3:
          // 注册  提交
          if (this.isRead) {
            // if (this.resultImg) {
            if (!val.password) {
              this.$toast("请输入密码");
              return false;
            }
            if (!validatePassword1(val.password)) {
              this.$toast("请输入密码，6-13位英文字母或数字");
              return false;
            }
            if (!val.confirmPassword) {
              this.$toast("请输入确认密码");
              return false;
            }
            if (!validatePassword1(val.confirmPassword)) {
              this.$toast("请输入密码，6-13位英文字母或数字");
              return false;
            }
            if (val.confirmPassword !== val.password) {
              this.$toast("密码输入不一致，请重新输入");
              return false;
            }
            _register({
              isRead: true,
              phone: encryptBy(this.phone),
              newPassword: encryptBy(this.password),
              confirmPassword: encryptBy(this.confirmPassword),
              origin: "C",
            }).then((res) => {
              if (res && res.code == 200) {
                this.$toast(res.message);
                // 上传签名
                // this.informedConsentUserRelation();
                // 转到登录
                this.updateFlag(1);
              } else {
                this.$toast(res.message);
              }
            });
            // } else {
            //   this.$toast("请签名");
            // }
          } else {
            this.$toast("请勾选并仔细阅读隐私协议");
          }
          break;
        case 4:
          // 修改密码，下一步
          if (!val.smsCode) {
            this.$toast("请输入验证码");
            return false;
          }
          if (!val.smsCode) {
            this.$toast("请输入验证码");
            return false;
          }
          _getCheckCode({
            phone: encryptBy(this.phone),
            code: this.smsCode,
            origin: "C",
          }).then((res) => {
            if (res && res.code == 200) {
              this.updateFlag(5);
            } else {
              this.$toast(res.message);
              return false;
            }
          });
          break;
        case 5:
          // 修改密码  提交
          if (!validatePassword1(val.password)) {
            this.$toast("请输入密码，6-13位英文字母或数字");
            return false;
          }
          if (!validatePassword1(val.confirmPassword)) {
            this.$toast("请输入密码，6-13位英文字母或数字");
            return false;
          }
          if (val.confirmPassword !== val.password) {
            this.$toast("请输入密码，6-13位英文字母或数字");
            return false;
          }
          _forgetPassword({
            phone: encryptBy(this.phone),
            newPassword: encryptBy(this.password),
            confirmPassword: encryptBy(this.confirmPassword),
            origin: "C",
          }).then((res) => {
            if (res && res.code == 200) {
              this.$toast(res.message);
              // 转到登录
              this.updateFlag(1);
            } else {
              this.$toast(res.message);
            }
          });
          break;
      }
    },
  },
  destroyed() {
    window.removeEventListener("popstate", this.goBack, false); //false阻止默认事件
  },
};
</script>
<style scoped lang="scss">
::v-deep .van-dialog__header {
  margin-bottom: 10px;
}
::v-deep .van-nav-bar__title {
  color: #161515;
}
.extra {
  margin-bottom: 40px;
}
.esign-clear {
  position: absolute;
  right: 30px;
  top: 5px;
  padding: 2px 5px;
  background-color: white;
  border-radius: 5px;
  color: #ff8340;
  font-size: 12px;
}

.login {
  // margin: 0 24px;
  // overflow: hidden;
  background: url("../../assets/images/login/login-bg.png") left top/100% 211px
    no-repeat;
  .logo {
    margin-top: 24px;
    width: 68px;
    // margin-left:154px;
    position: relative;
    left: 50%;
    margin-left: -34px;
  }
  .login-desc {
    margin-top: 20px;
    word-break: break-all;
    p {
      font-size: 14px !important;
    }
  }

  .indent2em {
    text-indent: 2em;
  }

  .frist-p {
    font-size: 18px;
    font-weight: 400;
    color: #000;
    line-height: 28px;
    margin-left: 30px;
    margin-bottom: 3px;

    .title-sub {
      font-size: 14px;
    }
  }
  .empty {
    height: 24px;
    margin-left: 30px;
  }
  .second-p {
    font-size: 14px;
    font-weight: 400;
    color: #8c93a0;
    line-height: 22px;
    margin-left: 30px;
  }
  .form-table {
    // margin-top: 27px;
    margin: 12px 30px 0;
    ::v-deep img.filedimg {
      margin-top: 7px;
    }

    ::v-deep .van-cell {
      padding: 11px 20px;
      line-height: 20px;
      font-size: 14px;
      box-sizing: border-box;
      border-bottom: 1px solid #eaeaea;
      background: #fff;
      box-shadow: 0px 2px 4px 0px rgba(14, 215, 225, 0.2);
      border-radius: 4px;
      .van-field__label {
        width: 39px;
        font-size: 16px;
        font-weight: 400;
        color: #000;
        border-right: 1px solid #999;
      }
      .push-btn {
        width: 110px;
        // height: 25px;
        background: transparent;
        // border-radius: 13px;
        // border: 1px solid #ff8340;
        font-size: 14px;
        padding: 0;
        opacity: 1;
        -webkit-appearance: none;
        outline: none;
        text-align: right;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #00aadf;
      }
    }

    .van-cell::after {
      border-bottom: 0;
    }

    .smsCode-input {
      padding: 11px 20px;
      margin-bottom: 40px;
    }

    .third-p {
      b {
        font-weight: 400;
      }

      font-size: 14px;
      font-weight: 400;
      color: #8c93a0;
      line-height: 20px;
      margin-top: 11px;

      .span-color {
        color: #8c93a0;
      }

      .defalut-b {
        font-weight: 400;
        color: #00aadf;
      }
      .defalut-regist {
        // background: linear-gradient(180deg, #ffc09f 0%, #ff8340 100%);
        color: #00aadf;
        // padding: 5px 10px;
        // border-radius: 20px;
      }
    }

    .margin145 {
      margin-top: 139px;
    }

    .margin45 {
      margin-top: 86px;
    }

    .btn-login {
      width: 315px;
      height: 46px;
      background: linear-gradient(180deg, #17e1eb 0%, #24bffb 100%);
      border-radius: 23px;
      font-size: 18px;
      border: 0;
    }

    .read-box {
      margin-top: 90px;
      // position: fixed;
      // bottom: 40px;
      // margin-bottom: 6px;
      align-items: center;
      //position: absolute;
      //top: 460px;
      //left: 20px;

      .read-img {
        width: 22px;
        height: 22px;
        // margin-right: 5px;
        // margin-top: 5px;
      }

      .read-span {
        font-size: 12px;
        color: #999;
      }
    }
  }
}

.register-code {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.informedConsent {
  width: 315px;
  height: 90%;
  background: #fff;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;

  p {
    padding: 0 0 0 20px;
  }
  .p18 {
    color: #000;
    margin-top: -10px;
    font-size: 16px;
    font-weight: 800;
    padding: 0;
  }

  .isReadBox {
    padding: 10px 20px 0;
  }

  .closePop {
    display: inline-block;
    position: absolute;
    top: 5px;
    right: 10px;
  }

  .esign {
    margin: 0 auto;
    // overflow-y: auto;
    display: flex;
    flex-direction: column;
    // height: 335px;
    height: 80%;
    margin-bottom: 30px;

    .content {
      margin-top: 5px;
      font-size: 12px !important;
      // padding-right: 6px;
    }

    .mainContent {
      // padding-bottom: 244px;
      flex: 1;
      overflow-y: auto;
      margin-right: 12px;
      position: relative;
      padding-right: 10px;
      ::v-deep .bscroll-vertical-scrollbar {
        margin-left: 10px;
        background-color: #f5e1d5;
        border-radius: 4px;
        width: 4px;
        overflow: visible !important;
        opacity: 1 !important;
        z-index: 100 !important;
        .bscroll-indicator {
          background-color: #ff8000 !important;
          border-radius: 4px !important;
          border-color: #ff8000 !important;
          // height: 12px !important;
        }
      }
      // &::-webkit-scrollbar-track {
      //   background-color: red;
      // }

      /* 定制滚动条 */

      &::-webkit-scrollbar {
        opacity: 0 !important;
        width: 0;
      }

      // &::-webkit-scrollbar-thumb {
      //   background-color: #ff8000 !important;
      //   border-radius: 4px !important;
      //   border-color: #ff8000 !important;
      // }

      // &::-webkit-scrollbar-track {
      //   border-radius: 8px;
      //   background-color: #e7c5af;
      // }
    }

    .footerEdit {
      // position: fixed;
      // bottom: 12%;
      // padding-bottom: 4px;
      background-color: #fff;
    }

    .gradientLayer {
      // width: 315px;
      // height: 75px;
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0.33) 0%,
        #fff 100%
      );
      border-radius: 2px;
      // bottom: 50px;
      position: absolute;
      overflow-x: hidden;
      height: 100%;
      width: 100%;
    }

    .drawingBoard {
      width: 275px;
      height: 100px;
      border-radius: 7px;
      z-index: 9;
      margin: 10px 20px;
      background: #ddd !important;
    }

    .p18 {
      text-align: center;
      margin: 0 !important;
    }
  }

  .code-btn {
    border-radius: 0 0 5px 5px;
    border: none;
    position: absolute;
    bottom: 0;
    width: 315px;
    height: 50px;
    background: #1dd1f2;
  }
}

.filedimg {
  width: 15px;
  // height: 8px;
}

.signature {
  width: 315px;
  height: 75px;
  background: rgba(243, 243, 243, 0.5) !important;
}

::v-deep .van-popup.van-popup--round {
  background: rgba(255, 255, 255, 0.4);
}

::v-deep .van-icon__image {
  width: 40px;
  height: 40px;
}
</style>
